import React from "react";

import mhsgImg from "./images/mhsg1.png";
import nssImg from "./images/nss.png";
import "./volunteer.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Volunteering = () => {
  return (
    <div className="volunteering" id="volunteering">
      <h1>Volunteering</h1>
      <hr></hr>
      <div className="row">
        <div className="col-md-3">
          <img src={mhsgImg} alt="BITS MHSG Logo"></img>
          <h5>May 2020 - Present</h5>
        </div>
        <div className="col-md-9 brief">
          <h4>Founder, Leader & Mentor | BITS Mental Health Support Group</h4>
          <p>
            During the pandemic lockdowns, I recognized the significant mental health challenges faced by students. I founded the Mental Health Support Group (MHSG) for BITSians, which has evolved into a formal student-led organization over three years. The initiative has grown significantly, with multiple team members and volunteers contributing to its mission.
          </p>
          <p>
            <b>Key Initiatives:</b>
          </p>
          <ul style={{marginLeft: "20px", marginTop: "10px"}}>
            <li>Organized virtual mental health awareness events and webinars</li>
            <li>Curated and shared informative content on mental health, stress management, and well-being</li>
            <li>Built a supportive community where students can seek help and share experiences</li>
            <li>Mentored and trained volunteer leaders to scale the initiative</li>
            <li>Advocated for mental health awareness within the campus community</li>
          </ul>
          <p style={{marginTop: "10px"}}>
            I remain dedicated to expanding the reach and impact of this initiative. If you'd like to contribute or learn more, feel free to reach out.
          </p>
        </div>
      </div>
      <hr></hr>
      <div className="row">
        <div className="col-md-3">
          <img src={nssImg} alt="NSS Logo"></img>
          <h5>Aug 2016 - Apr 2019</h5>
        </div>
        <div className="col-md-9 brief">
          <h4>Core Member | National Service Scheme (NSS)</h4>
          <p>
            As a dedicated member of the National Service Scheme, I actively participated in meaningful social causes and community development initiatives. My involvement spanned three years, during which I collaborated with volunteers, local authorities, and organization professionals to create positive social impact.
          </p>
          <p>
            <b>Key Activities & Contributions:</b>
          </p>
          <ul style={{marginLeft: "20px", marginTop: "10px"}}>
            <li>Organized and participated in blood donation camps to support healthcare initiatives</li>
            <li>Led tree plantation drives focused on environmental conservation and sustainability</li>
            <li>Conducted campus and community cleaning drives to promote sanitation awareness</li>
            <li>Visited orphanages and old age homes to provide support and compassion</li>
            <li>Raised awareness about critical social issues including education, health, and environment</li>
            <li>Collaborated with team members and local communities to ensure successful execution of all initiatives</li>
          </ul>
          <p style={{marginTop: "10px"}}>
            Through this experience, I developed a deep commitment to social responsibility and fostered a more compassionate and inclusive society.
          </p>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

export default Volunteering;
